<template>
    <nav class="decade-nav-mobile" v-if="selectedDecade !== 0">
      <div v-if="selectedDecade !== decades[0]">
        <a href="#" @click.prevent="handleDecadeSelect(selectedDecade - 10)">{{ (selectedDecade - 10) + 's' }}</a>
      </div>
      <div v-if="selectedDecade !== decades[decades.length - 1]">
        <a href="#" @click.prevent="handleDecadeSelect(selectedDecade + 10)">{{ (selectedDecade + 10) + 's' }}</a>
      </div>
    </nav>
  </template>
  
  <script>
  import { mapActions, mapGetters } from 'vuex';
  
  export default {
    computed: {
      ...mapGetters(['decades', 'selectedDecade'])
    },
    methods: {
      ...mapActions(['selectDecade']),
      handleDecadeSelect(decade) {
        this.selectDecade(decade);
      }
    }
  };
</script>
  


// WEBPACK FOOTER //
// DecadeNavMobile.vue?768fab9e